//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

//* Utils imports
import { QUERY_KEYS, queryInvalidator } from "@/utils/query-client";

//* Types imports
import type { ISaleInputDTO } from "@/schemas";

async function createSale(data: ISaleInputDTO) {
  const response = await fetch(`${API_URL}/sales`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Falha ao criar venda");
  }

  return response.json();
}

export function useCreateSale() {
  return useMutation({
    mutationFn: createSale,
    onSuccess: async () => {
      await queryInvalidator([[QUERY_KEYS.SALES.ALL]]);
      toast.success("Venda criada com sucesso!");
    },
  });
}
